import { createRouter, createWebHistory } from "vue-router";
import NewsDetail from '../views/NewsDetail.vue'

const routes = [
  { path: "/", name: "Index", component: () => import("../views/Index.vue"), meta: { title: "首页" } },
  { path: "/product", name: "Product", component: () => import("../views/Product.vue"), meta: { title: "首页" } },
  { path: "/news", name: "News", component: () => import("../views/News.vue"), meta: { title: "政策资讯" } },
  { path: "/material", name: "Material", component: () => import("../views/Material.vue"), meta: { title: "材料下载" } },
  { path: "/faq", name: "Faq", component: () => import("../views/Faq.vue"), meta: { title: "常见问题" } },
  { path: "/user/login", name: "Login", component: () => import("../views/User/Login.vue"), meta: { title: "登录" } },
  { path: "/user/register", name: "Register", component: () => import("../views/User/Register.vue"), meta: { title: "注册" } },
  {
    path: "/user/info",
    name: "UserInfo",
    component: () => import("../views/User/UserInfo.vue"),
    meta: { title: "用户中心" },
    redirect: "/user/info/user",
    children: [
      { path: "/user/info/user", name: "UserInfoInfo", component: () => import("../views/User/UserInfoInfo.vue"), meta: { title: "用户中心" } },
      { path: "/user/info/account", name: "UserInfoAccount", component: () => import("../views/User/UserInfoAccount.vue"), meta: { title: "账号资料" } },
      { path: "/user/info/safe", name: "UserInfoSafe", component: () => import("../views/User/UserInfoSafe.vue"), meta: { title: "账号安全" } },
      { path: "/user/info/order", name: "UserInfoOrder", component: () => import("../views/User/UserOrder.vue"), meta: { title: "我的订单" } },
      { path: "/user/info/order/pay/:id", name: "UserOrderPay", component: () => import("../views/User/OrderPay.vue"), meta: { title: "订单支付" } },
      { path: "/user/info/notice", name: "UserInfoNotice", component: () => import("../views/User/UserNotification.vue"), meta: { title: "消息通知" } },
    ],
  },
  { path: "/filing/:type", name: "FilingApply", component: () => import("../views/FilingApply.vue"), meta: { title: "备案办理" } },
  { path: "/business", name: "Business", component: () => import("../views/Business.vue"), meta: { title: "业务办理" } },
  { path: "/payment/return", name: "PaymentReturn", component: () => import("../views/PaymentReturn.vue"), meta: { title: "支付结果" } },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: NewsDetail
  },
  { path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("../views/NotFound.vue"), meta: { title: "404" } },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 80 };
    }
    if (savedPosition) return savedPosition;
    return { top: 0, left: 0 };
  },
});
//  跳转时候设置 title
router.beforeEach((to, from, next) => {
  next();
});

export default router;
